import { createContext } from 'react'

import { EnvironmentTypeEnum } from './EnvironmentTypeEnum'

export const EnvironmentTypeContext = createContext<
  EnvironmentTypeEnum | undefined
>(undefined)
